module.exports = __webpack_public_path__ + "media/images/icon_plus-4b539cb1a4dc146a0e9204a572ba4c63.svg";